import styled from 'styled-components';
import { DIRECTION } from '../constants.js';
import { BREAKPOINTS } from '../../spacing/index.js';
import { typography } from '../../typography/typography.js';

var Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-1f2qsz0-0"
})([""]);
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : void 0;
var Box = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Box",
  componentId: "sc-1f2qsz0-1"
})(["padding:0.5em 0.5em;margin-top:10px;border-radius:3px;transition:border 0.5s ease-in-out;"]);
process.env.NODE_ENV !== "production" ? Box.displayName = 'Box' : void 0;
var Fieldset = /*#__PURE__*/styled.fieldset.withConfig({
  displayName: "styledComponents__Fieldset",
  componentId: "sc-1f2qsz0-2"
})(["padding:0px;border:none;"]);
process.env.NODE_ENV !== "production" ? Fieldset.displayName = 'Fieldset' : void 0;
var FlexBox = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__FlexBox",
  componentId: "sc-1f2qsz0-3"
})(["display:flex;flex:1 1 auto;flex-wrap:wrap;flex-direction:", ";justify-content:", ";@media screen and (max-width:", "px){flex-direction:", ";}"], function (_ref) {
  var direction = _ref.direction;
  return direction;
}, function (_ref2) {
  var alignment = _ref2.alignment;
  return alignment;
}, BREAKPOINTS.PHONE_PORTRAIT_LG, function (_ref3) {
  var mobileDirection = _ref3.mobileDirection;
  return mobileDirection;
});
process.env.NODE_ENV !== "production" ? FlexBox.displayName = 'FlexBox' : void 0;
var ItemGroup = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__ItemGroup",
  componentId: "sc-1f2qsz0-4"
})(["display:flex;flex:1 1 auto;align-items:flex-start;margin-top:16px;", " @media screen and (max-width:", "px){", "}@media screen and (max-width:", "px){margin-top:11px;max-width:100%;", "}@media screen and (min-width:", "px){", "}"], function (_ref4) {
  var direction = _ref4.direction;
  return direction === DIRECTION.ROW && "max-width: 33%;";
}, BREAKPOINTS.TABLET_PORTRAIT, function (_ref5) {
  var direction = _ref5.direction;
  return direction === DIRECTION.ROW && "max-width: 67%;";
}, BREAKPOINTS.PHONE_PORTRAIT_LG, function (_ref6) {
  var mobileDirection = _ref6.mobileDirection;
  return mobileDirection === DIRECTION.ROW && "flex: 1 1 0;";
}, BREAKPOINTS.PHONE_PORTRAIT_LG, function (_ref7) {
  var direction = _ref7.direction;
  return direction === DIRECTION.ROW ? "margin-left: 30px;\n            margin-top: 11px;\n            &:first-of-type {\n              margin-left: 0;\n            }" : "&:first-of-type {\n              margin-top: 11px;\n            }";
});
process.env.NODE_ENV !== "production" ? ItemGroup.displayName = 'ItemGroup' : void 0;
var Label = /*#__PURE__*/styled.label.withConfig({
  displayName: "styledComponents__Label",
  componentId: "sc-1f2qsz0-5"
})(["align-self:center;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";vertical-align:middle;cursor:", ";color:", ";", ""], typography.fontFamily, typography.fontSize, function (_ref8) {
  var checked = _ref8.checked;
  return checked ? '400' : '300';
}, typography.lineHeight, function (_ref9) {
  var isDisabled = _ref9.isDisabled;
  return isDisabled ? 'not-allowed' : 'pointer';
}, function (_ref10) {
  var isDisabled = _ref10.isDisabled,
      theme = _ref10.theme;
  return isDisabled ? theme.colorPalette.neutralColors.dark.shade_light_4 : theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref11) {
  var labelStyle = _ref11.labelStyle;
  return labelStyle;
});
process.env.NODE_ENV !== "production" ? Label.displayName = 'Label' : void 0;

export { Box, Fieldset, FlexBox, ItemGroup, Label, Root };
